"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPopperActions = void 0;
var core_1 = require("@popperjs/core");
function createPopperActions() {
    var popperInstance;
    var referenceNode;
    var contentNode;
    var options;
    function initPopper() {
        if (referenceNode && contentNode) {
            popperInstance = core_1.createPopper(referenceNode, contentNode, options);
        }
    }
    function deinitPopper() {
        if (popperInstance) {
            popperInstance.destroy();
            popperInstance = null;
        }
    }
    function referenceAction(node) {
        referenceNode = node;
        initPopper();
        return {
            destroy: function () {
                deinitPopper();
            }
        };
    }
    function contentAction(node, popperOptions) {
        contentNode = node;
        options = popperOptions;
        initPopper();
        return {
            update: function (popperOptions) {
                options = popperOptions;
                if (popperInstance)
                    popperInstance.setOptions(options);
            },
            destroy: function () {
                deinitPopper();
            }
        };
    }
    return [referenceAction, contentAction];
}
exports.createPopperActions = createPopperActions;
exports.default = { createPopperActions: createPopperActions };
